import _util from '../../utils/';

const weeklyReportService = {
	initWeeklyReport(gets, resolve, reject) {
		_util.request({
			// url: '/api/HRWorkReportMyWeekly/Post',
			url: '/api/HRWorkReport/Post',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	saveWeeklyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	fetchWeeklyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	updateWeeklyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
	emailRetryWeeklyWorkReport(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/EmailRetryWeeklyReport',
			params: params,
			success: resolve,
			error: reject
		})		
	},
	fetchWeeklyReportDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/Details',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	multiDeleteWeeklyReport(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/Delete',
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		})
	},
	submitWeeklyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/SubmitReport',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
	submitCurrentWeeklyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyWeekly/SubmitCurrentReport',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
	
	fetchLeaderWeeklyReportList(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklyManagement/Get',
			params: params,
			success: resolve,
			error: reject
		})
	},
	fetchLeaderWeeklyReportDetail(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklyManagement/Details',
			params: params,
			success: resolve,
			error: reject
		})
	},
	replyWeeklyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportReply/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	multiNotifyWeeklyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklyManagement/SendNotification',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	confirmWeeklyReportDateAllow(params, resolve, reject){
		_util.request({
			url: '/api/HRWorkReportWeeklyManagement/ConfirmWeeklyReportDateAllow',
			params: params,
			success: resolve,
			error: reject
		})
	}
}


export default weeklyReportService




// WEBPACK FOOTER //
// ./src/services/WorkReport/weekly-report-service.js